var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-switch-screen" },
    [
      _vm.loading
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "toolbar-left" }, [
          _c(
            "i",
            {
              staticClass: "material-icons toolbar-back-icon",
              on: { click: _vm.close },
            },
            [_vm._v("arrow_back")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "toolbar-title" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.systemStatus"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "toolbar-actions" }, [
          _c(
            "button",
            {
              staticClass: "toolbar-btn toolbar-btn-refresh",
              on: { click: _vm.refresh },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("refresh")]),
              _vm._v(" "),
              _c("span", { staticClass: "btn-text" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.refresh"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "toolbar-shortcut" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.refreshShortcutKey"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "toolbar-btn toolbar-btn-close",
              on: { click: _vm.close },
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "summary" }, [
        _c("div", { staticClass: "summary-card" }, [
          _c("i", { staticClass: "material-icons card-icon" }, [
            _vm._v("person"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("span", { staticClass: "card-label" }, [
              _vm._v(_vm._s(_vm.$t("chatWindow.totalCustomers"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "card-value" }, [
              _vm._v(_vm._s(_vm.summary.totalCustomers)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "summary-card" }, [
          _c("i", { staticClass: "material-icons card-icon" }, [
            _vm._v("check_circle"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("span", { staticClass: "card-label" }, [
              _vm._v(_vm._s(_vm.$t("chatWindow.totalAnswered"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "card-value" }, [
              _vm._v(_vm._s(_vm.summary.totalAnswered)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "summary-card" }, [
          _c("i", { staticClass: "material-icons card-icon" }, [
            _vm._v("description"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("span", { staticClass: "card-label" }, [
              _vm._v(_vm._s(_vm.$t("chatWindow.waitingAnswer"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "card-value" }, [
              _vm._v(_vm._s(_vm.summary.waitingAnswer)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "summary-card" }, [
          _c("i", { staticClass: "material-icons card-icon" }, [
            _vm._v("support_agent"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("span", { staticClass: "card-label" }, [
              _vm._v(_vm._s(_vm.$t("chatWindow.totalAgentInChat"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "card-value" }, [
              _vm._v(_vm._s(_vm.summary.totalAgentInChat)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "summary-card summary-card-online" }, [
          _c("i", { staticClass: "material-icons card-icon" }, [
            _vm._v("support_agent"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("span", { staticClass: "card-label" }, [
              _vm._v(_vm._s(_vm.$t("chatWindow.onlineAgentCount"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "card-value" }, [
              _vm._v(_vm._s(_vm.summary.onlineAgentCount)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agent-filters" },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("message.filterBy")) + "\n        "
          ),
          _c("CircleUserSelect", {
            attrs: {
              users: _vm.onlineUsers,
              value: _vm.selectedUserId,
              nullable: "",
            },
            on: { input: _vm.changeAgentFilter },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "groups mt-2" },
        _vm._l(_vm.groupsByKeys, function (group) {
          return _c("ChatGroup", {
            key: group,
            attrs: {
              group: _vm.groups[group],
              "selected-item-id": _vm.selectedItemId,
              users: _vm.users,
            },
            on: {
              "watch-all": function ($event) {
                return _vm.watchAll(group)
              },
              "select-customer": _vm.select,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }